import { splitLocation } from '../../utils/OneSearchLocation';
import { Features } from './Features';

interface IVersions {
  fssInputCategory: boolean;
}

export interface IMarketConfig {
  language: string;
  market: string;
  locale: string;
  features: Features;
  featureType: IVersions;
  sp: string;
}

/**
 * @config
 * Configuration used for each market.
 */
export class MarketConfig implements IMarketConfig {
  /**
   * The language defined for the market 'de'
   */
  language: string;
  /**
   * The market defined for the marker 'DE'
   */
  market: string;
  /**
   * The locale defined for the market 'de_DE'
   */
  locale: string;
  /**
   * Features available for this market
   */
  features: Features;
  /**
   * Feature type used on the search input
   */
  featureType: IVersions;
  /**
   * Search profile for the market
   */
  sp: string;
  /**
   * Text direction for the markert 'rtl'
   */
  texDirection: string;

  constructor(locale: string, features: Features, featureType: IVersions, sp: string, texDirection: string = '') {
    this.language = splitLocation(locale).lang;
    this.market = splitLocation(locale).market;
    this.locale = locale;
    this.features = features;
    this.featureType = featureType;
    this.sp = sp;
    this.texDirection = texDirection;
  }
}
